import indexMixin from "../mixins/index";
export default {
  name: "res-radio",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value // layout：horizontal、vertical(只对非button模式起作用)

    };
  },

  props: {
    isButton: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: "value"
    },
    labelKey: {
      type: String,
      default: "label"
    },
    border: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Boolean, Number]
    }
  },
  computed: {
    valueToLabel() {
      let label = "";
      this.options.some(item => {
        if (item[this.valueKey] === this.dataModel) {
          label = item[this.labelKey];
          return true;
        }
      }); // 没有label默认取value值

      return label || this.dataModel;
    }

  },
  watch: {
    dataModel(val) {
      this.$emit("input", val);
    },

    value(val) {
      this.dataModel = val;
    }

  }
};